import { History } from "@mui/icons-material";
import { Alert, Box, Typography } from "@mui/material";
import { EdmButton } from "atoms";
import { Page } from "organisms";
import { useAuthenticated, useTranslate } from "react-admin";

export default function EdmNotFound() {
  const translate = useTranslate();
  const { authenticated } = useAuthenticated();

  if (!authenticated) {
    return null;
  }

  return (
    <Page>
      <Box display="flex" alignItems="center" gap={2} mb={4}>
        <Typography variant="h5" component="h1">
          {translate("ra.message.not_found")}
        </Typography>
      </Box>
      <Alert severity="info" sx={{ maxWidth: "60em", mb: 4 }}>
        {translate("hints.not_found_info")}
      </Alert>

      <EdmButton onClick={() => history.go(-1)} label={translate("ra.action.back")} sx={{ mt: 4 }}>
        <History />
      </EdmButton>
    </Page>
  );
}
